import { useEffect, useLayoutEffect, useRef } from "react";
import { useAuth } from "@/lib/auth";
import { HitRing } from "./HitButton";
import { HitSectionLoading } from "./HitSectionLoading";
import { useLoadingLevel } from "./hooks";
import { useFullLoader } from "./store";

// Texto de un botón existente con estado de carga (C2): anillo + gerundio, ancho fijo y aria-busy.
export function BusyLabel({ busy, text, tone = "light", children }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const b = ref.current?.closest("button");
    if (!b) return;
    if (busy) { b.style.minWidth = `${b._hitW || b.offsetWidth}px`; b.setAttribute("aria-busy", "true"); b.setAttribute("aria-disabled", "true"); }
    else { b._hitW = b.offsetWidth; b.style.minWidth = ""; b.removeAttribute("aria-busy"); b.removeAttribute("aria-disabled"); }
  }, [busy]);
  return (
    <span ref={ref} className="inline-flex items-center justify-center gap-2">
      {busy ? <><HitRing tone={tone} />{text}</> : children}
    </span>
  );
}

// Bloque que solo se monta mientras carga (componentes pequeños): aplica los umbrales.
export function HitLoadingBlock({ section, className = "", grid = false, onRetry }) {
  const level = useLoadingLevel(true);
  return <HitSectionLoading level={level} loading section={section} grid={grid} className={className} onRetry={onRetry} />;
}

let booted = false;
export const isBooted = () => booted;

// Nivel A solo en la primera carga de la app (validación de la sesión).
export function AppBoot() {
  const { loading } = useAuth();
  const level = useLoadingLevel(loading && !booted, { heavy: true });
  useEffect(() => { if (!loading) booted = true; }, [loading]);
  useFullLoader(level === "full", { step: loading ? 0 : 3 });
  return null;
}
